import React from "react";

/**
 * Totals block. Always shows subtotal + grand total; only shows
 * tax / discount rows when the corresponding amount is non-zero
 * (keeping "$0.00" rows would clutter a simple two-item invoice).
 *
 * The "zero" check compares against the pre-formatted display
 * string `"$0.00 USDC"` / `"0 ETH"` — conservative: only hides
 * when we're certain the value is zero, not when it's merely
 * small.
 */
export function InvoiceTotals({
  subtotalDisplay,
  taxDisplay,
  discountDisplay,
  totalDisplay,
}) {
  const showTax = taxDisplay && !isZeroDisplay(taxDisplay);
  const showDiscount = discountDisplay && !isZeroDisplay(discountDisplay);
  return (
    <div className="pay-invoice-totals">
      <div className="pay-invoice-totals__row">
        <span className="pay-invoice-totals__label">Subtotal</span>
        <span className="pay-invoice-totals__value">{subtotalDisplay}</span>
      </div>
      {showTax && (
        <div className="pay-invoice-totals__row">
          <span className="pay-invoice-totals__label">Tax</span>
          <span className="pay-invoice-totals__value">{taxDisplay}</span>
        </div>
      )}
      {showDiscount && (
        <div className="pay-invoice-totals__row">
          <span className="pay-invoice-totals__label">Discount</span>
          <span className="pay-invoice-totals__value">
            −{discountDisplay}
          </span>
        </div>
      )}
      <div className="pay-invoice-totals__row pay-invoice-totals__row--grand">
        <span className="pay-invoice-totals__label">Total due</span>
        <span className="pay-invoice-totals__value">{totalDisplay}</span>
      </div>
    </div>
  );
}

function isZeroDisplay(s) {
  // Matches "$0.00 USDC" / "$0.00" / "0 ETH" / "0.00 ETH".
  return /^(?:\$)?0(?:\.0+)?(?:\s\w+)?$/.test(String(s).trim());
}
